import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { usePoint } from "@/domains/point";
import { useAppSelector } from "@/hooks/redux";
import { Loading } from "@/shared/feedback/Loading";
import { Header } from "@/shared/layout";
import { BlockList } from "@/shared/pageComposition/BlockList";
import { Meta } from "@/shared/seo";

import { StyledAPContainer } from "../../Styled";
import {
    getInfoTabShelvesBlocks,
    InfoTabShelvesModel,
} from "./InfoTabShelves.blocks";
import { getInfoTabShelvesCapabilities } from "./InfoTabShelves.policy";

const InfoTabShelves = () => {
    const { pointId } = useParams<{ pointId: string }>();
    const role = useAppSelector((state) => state.user.role);

    const { point, pointLoading } = usePoint(pointId);

    const currentPointShelves = point?.context?.shelfSize;

    const shelvesLengthMeters = useMemo(
        () => (currentPointShelves?.total ?? 0) / 100,
        [currentPointShelves?.total],
    );

    const isShelvesEmpty =
        !currentPointShelves?.total || !currentPointShelves.shelving?.length;

    const capabilities = useMemo(
        () => getInfoTabShelvesCapabilities(role),
        [role],
    );

    const model: InfoTabShelvesModel = useMemo(
        () => ({
            capabilities,
            shelves: {
                shelvesLengthMeters,
                totalCm: currentPointShelves?.total ?? 0,
                racks: currentPointShelves?.shelving ?? [],
                isEmpty: isShelvesEmpty,
            },
        }),
        [
            capabilities,
            shelvesLengthMeters,
            currentPointShelves?.total,
            currentPointShelves?.shelving,
            isShelvesEmpty,
        ],
    );

    const blocks = useMemo(() => getInfoTabShelvesBlocks(model), [model]);

    if (pointLoading) return <Loading />;

    return (
        <>
            <Meta title="TT Info Shelves" />
            <Header title="Конфігурація полиць" back titleFontSize={16} />

            <StyledAPContainer>
                <BlockList blocks={blocks} model={model} />
            </StyledAPContainer>
        </>
    );
};

export default InfoTabShelves;
